import { useMutation } from 'react-apollo'
import { DeletePackage } from '../../../graphql/packages/mutations'

/**
 *  Deletes a package (aka orderset)

 * @returns Package
 */

export const useMutationDeletePackageApi = () => {
  const [deletePackage, { data: deletePackageData, error: deletePackageError, loading: deletePackageLoading }] = useMutation(DeletePackage, {})

  return [
    deletePackage,
    {
      data: deletePackageData,
      error: deletePackageError,
      loading: deletePackageLoading,
    },
  ] as const
}
